module.exports = {
  useInProduction: true,
  apiOptions: {
    authToken: "3bd86a71bd7541c482a05b153123c62774476c674b05470ab4e16c8830df3ecb",
    org: "ll-gb",
    project: "web-client",
  },
  dsn: "https://ee5b8530f68541818d21a7daea66ff86@o471200.ingest.sentry.io/5502904",
};
